//** NEW TEMPLATE
import React, { useEffect, useState, useRef } from "react";
import { renderLangString } from "../../languageStrings";

// COMPONENTS
import Icon from "../icons/Icon";
import Layout from "../layout/Layout";

// HOOKS
import useScroll from "../../hooks/useScroll";

const DisplayScore = ({ id, score, addClass, style, savedStatus, confirmed }) => {
  const [savedState, setSavedState] = useState(0);
  const scrollData = useScroll();
  const wrapp = useRef();

  useEffect(() => {
    if (savedStatus === "saving") {
      setSavedState(1);
    } else if (savedStatus === "saved") {
      setSavedState(2);
    }

    const timeout = setTimeout(() => {
      setSavedState(0);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [savedStatus]);

  useEffect(() => {}, [scrollData]);

  return (
    <div
      id={id}
      ref={wrapp}
      className={`__z ${addClass}`}
      style={style || {}}
      data-name="DisplayScore"
      data-test="DisplayScore"
    >
      <Layout flex spaceBetween>
        {confirmed && (
          <div className="__zn" data-test="DisplayScoreCheck">
            <span className="__zc">
              <Icon iconId="checkLine" addClass="__zi" />
            </span>
          </div>
        )}
        <Layout flex flex1 justifyContentCenter>
          {savedState === 1 && (
            <span className="__zs" data-test="DisplayScoreSavingMsg">
              {renderLangString({ id: "$_d2" })}
            </span>
          )}
          {savedState === 2 && (
            <span className="__zs" data-test="DisplayScoreSavingMsg">
              {renderLangString({ id: "$_d3" })}
            </span>
          )}

          {savedState === 0 && (
            <span className="__zs" data-test="DisplayScoreValue">
              <Icon iconId="cup" addClass="__zi" />
              {score || "-"}
            </span>
          )}
        </Layout>
      </Layout>
    </div>
  );
};

export default DisplayScore;
